import React from "react";
import { connect, useDispatch } from "react-redux";
import Skeleton from "@mui/material/Skeleton";
// icons
import { IoMdGitPullRequest } from "react-icons/io";
import { RiRobot2Fill } from "react-icons/ri";
import { FaVideo } from "react-icons/fa6";
import { XCircle } from "@phosphor-icons/react";
import { Eye } from "@phosphor-icons/react";
import { GetMissedChats } from "../../../../Redux/Actions/actions";
import { randomColors } from "../../../../Utils/colorpallet";
import {
  Typography,
  Stack,
  Box,
  Avatar,
  IconButton,
  Badge,
  styled,
} from "@mui/material";
import axios from "axios";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import { toaststyle } from "../../../../Utils/toaststyle";
import moment from "moment";
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const StyledBadge2 = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#E91E63",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));
const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    missedChats: contactListData.missedChats,
    externalChatData: contactListData.externalChatData,
  };
};
const MissedChat = (props) => {
  const { contact, index, missedChat } = props;
  const Dispatch = useDispatch();
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  const pullChat = (value) => {
    axios
      .post(
        BaseUrl + "/users/assignpurpletoagent",
        {
          chat_session_id: value,
          agentId: loggedInAgent.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          const newlist = props.missedChats.filter(
            (item) => item.chat_session_id != value
          );
          Dispatch({ type: "MISSED_CHATS", val: newlist });
        }
      })
      .catch((err) => {});
  };
  const EndPurpleSession = (value) => {
    axios
      .post(
        BaseUrl + "/users/EndPurplesession",
        {
          chat_session_id: value,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          const newlist = props.missedChats.filter(
            (item) => item.chat_session_id != value
          );
          Dispatch({ type: "MISSED_CHATS", val: newlist });
          toast.success("Chat Ended Successfully", toaststyle);
        }
      })
      .catch((err) => {
        console.log("EndPurpleSession", err);
      });
  };
  const name = (contact) => {
    if (contact.channel == "voice") {
      return contact.unique_id.phonenumber.slice(0, 2);
    } else if (contact.channel == "email") {
      return contact.unique_id.email.slice(0, 2).toUpperCase();
    } else {
      return contact.unique_id.username.slice(0, 2).toUpperCase();
    }
  };

  const isExpired = moment().diff(moment(contact.arrival_at), "hours") < 24;
  return (
    <div
      className={
        props.externalChatData
          ? props.externalChatData.id == contact.id
            ? "d-flex chat-active"
            : "chat-contact d-flex"
          : "chat-contact d-flex"
      }
      style={{
        cursor: "pointer",
        width: "100%",
        userSelect: "none",
        padding: "5px 5px",
        marginBottom: "2px",
      }}
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        spacing={0.5}
        sx={{ width: "100%", height: "100%" }}
      >
        <Box className="position-relative">
          {/* user profile  */}
          {isExpired ? (
            <StyledBadge
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              {props.contactlistLoader ? (
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={35}
                  height={35}
                />
              ) : (
                <Avatar
                  className="box-inset2 position-relative"
                  sx={{
                    background: randomColors[index],
                    height: "35px",
                    width: "35px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {name(contact)}
                </Avatar>
              )}
            </StyledBadge>
          ) : (
            <StyledBadge2
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              {props.contactlistLoader ? (
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={35}
                  height={35}
                />
              ) : (
                <Avatar
                  className="box-inset2 position-relative"
                  sx={{
                    background: randomColors[index],
                    height: "35px",
                    width: "35px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {name(contact)}
                </Avatar>
              )}
            </StyledBadge2>
          )}
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "100%",
          }}
        >
          {props.contactlistLoader ? (
            <Skeleton
              animation="wave"
              variant="rectangular"
              width={100}
              height={10}
            />
          ) : (
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Typography
                noWrap
                sx={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#0b3363",
                }}
              >
                {contact.channel === "email"
                  ? contact.email
                  : contact.unique_id.username
                    ? contact.unique_id.username
                    : contact.unique_id.phonenumber}
              </Typography>
              {/* channel  */}
              {contact.channel === "from_purple" ? (
                <div className="twit-bg chat-social d-flex justify-content-center align-items-center ms-3">
                  <RiRobot2Fill size={10} />
                </div>
              ) : (
                <div className="twit-bg chat-social d-flex justify-content-center align-items-center ms-3">
                  <FaVideo size={10} />
                </div>
              )}
              <Typography className="ms-2" onClick={() => missedChat(contact)}>
                <Eye size={14} />
              </Typography>
            </Stack>
          )}

          <Stack
            direction={"row"}
            alignItems={"center"}
            sx={{
              width: "100%",
            }}
            spacing={1}
          >
            <Typography variant="caption" sx={{ fontSize: "10px" }}>
              {contact.skillset}
            </Typography>
            <Stack direction={"row"}>
              {isExpired && (
                <>
                  {props.contactlistLoader ? (
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      width={60}
                      height={10}
                      sx={{ marginTop: "10px" }}
                    />
                  ) : (
                    <Typography
                      aria-label="delete"
                      className="ms-3"
                      onClick={() => {
                        pullChat(contact.chat_session_id);
                      }}
                    >
                      <IoMdGitPullRequest size={12} />
                    </Typography>
                  )}
                </>
              )}

              {props.contactlistLoader ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={60}
                  height={10}
                  sx={{ marginTop: "10px" }}
                />
              ) : (
                <Typography
                  aria-label="delete"
                  className="ms-2"
                  onClick={() => {
                    EndPurpleSession(contact.chat_session_id);
                  }}
                >
                  <XCircle size={12} />
                </Typography>
              )}
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </div>
  );
};

export default connect(mapStateToProps, {
  GetMissedChats,
})(MissedChat);
